import React from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { getWeekDay } from '../../utils';

function TimesheetDescriptionWeekDay(props) {

    const { date } = props;

    const descriptionWeekDay = () => {
        const weekDay = getWeekDay(date);

        let weekday = new Array(7);
        weekday[0] = `${i18next.t("weekday:week.sunday")}`;
        weekday[1] = `${i18next.t("weekday:week.monday")}`;
        weekday[2] = `${i18next.t("weekday:week.tuesday")}`;
        weekday[3] = `${i18next.t("weekday:week.wednesday")}`;
        weekday[4] = `${i18next.t("weekday:week.thursday")}`;
        weekday[5] = `${i18next.t("weekday:week.friday")}`;
        weekday[6] = `${i18next.t("weekday:week.saturday")}`;

        return weekday[weekDay];
    }

    return (
        <span>{descriptionWeekDay()}</span>
    )
}

export default withNamespaces(['weekday'], { wait: true })(TimesheetDescriptionWeekDay);